// extracted by mini-css-extract-plugin
module.exports = {"table":"MDXComponents_table__jF6TI","ul":"MDXComponents_ul__0Bb7y","ol":"MDXComponents_ol__uW3mL","section":"MDXComponents_section__JU7_S","callout":"MDXComponents_callout__8HFjY"};